import React from "react";
import { useAuth } from "@/hooks/useAuth";
import { Button } from "@/components/ui/button";
import { LogOut, User } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { supabase } from "@/lib/supabaseClient";

const AdminHeader: React.FC = () => {
  const { session } = useAuth();
  const navigate = useNavigate();
  const email = session?.user?.email ?? "";

  const handleLogout = async () => {
    try {
      await supabase?.auth.signOut();
      toast.success("Logout realizado com sucesso!");
      navigate("/admin-login");
    } catch (error) {
      toast.error("Erro ao fazer logout");
    }
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Painel Toc Toc Admin</h1>
          <p className="text-sm text-gray-600">Gerencie seu conteúdo</p>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <User className="w-4 h-4" />
            <span>{email}</span>
          </div>
          <Button
            onClick={handleLogout}
            variant="outline"
            size="sm"
            className="text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sair
          </Button>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
